import React from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { StyledButton } from '../../../Components/Generics.styled';
import DownloadPDFImg from '../../../Assets/download-pdf.png';
import NewCreativeImg from '../../../Assets/new-creative.png';
import UpdateStrategyImg from '../../../Assets/update-strategy.png';
import ViewCampaignsImg from '../../../Assets/view-campaigns.png';
import AccountImg from '../../../Assets/account.png';

import propTypes from 'prop-types';

const SettingsContainer = styled.div`
    min-height: 800px;
    display: flex;
    flex-direction: column;
`;

const OptionsContainer = styled.div`
    display: flex;
    margin-left: auto;
    margin-right: auto;
    gap: 30px;
    margin-top: 100px;
`;

const OptionsRow = styled.div`
    /* border: 1px solid red; */
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

const SettingsBox = styled.div`
    border: 1px solid blue;
    height: 100px;
    width: 400px;
    margin: 50px;
    padding: 8px;
    border-radius: 20px;
    cursor: pointer;
    :hover {
        background-color: #2e69fe;
        color: #fafbf7;
    }
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
    padding-top: 60px;
`;

const AppletContainer = styled.div`
    border: 1px solid black;
    border-radius: 12px;
    min-width: 360px;
    min-height: 360px;
    display: flex;
    flex-direction: column;
    background-color: #fafbf7;
    align-items: center;
    justify-content: center;
`;

const ImageContainer = styled.div`
    max-width: 250px;
`;

const Image = styled.img`
    object-fit: contain;
    width: 100%;
`;

const DashButtons = styled(StyledButton)`
    font-size: 23px;
    padding: 12px;
    padding-left: 24px;
    padding-right: 24px;
    font-weight: 400;
    max-width: unset;
    max-height: unset;
`;

const StyledApplet = ({ image, altText, btnText, onClick }) => {
    return (
        <AppletContainer>
            <ImageContainer>
                <Image src={image} alt={altText} />
            </ImageContainer>
            <DashButtons onClick={onClick}>{btnText}</DashButtons>
        </AppletContainer>
    );
};
StyledApplet.propTypes = {
    image: propTypes.node,
    altText: propTypes.string,
    btnText: propTypes.string,
    onClick: propTypes.func,
};

StyledApplet.defaultProps = {
    image: <div />,
    altText: '',
    btnText: '',
    onClick: () => {},
};

const Settings = () => {
    const history = useHistory();
    return (
        <>
            <SettingsContainer>
                <Title>Settings</Title>

                <OptionsContainer>
                    <OptionsRow>
                        <StyledApplet
                            image={AccountImg}
                            altText={'update-account'}
                            btnText={'Update Account'}
                            onClick={() => {
                                history.push('/portal/settings/accountInformation');
                            }}
                        />
                        {/* <StyledApplet
                            image={NewCreativeImg}
                            altText={'update-strategy'}
                            btnText={'Update Strategy'}
                            onClick={() => {
                                history.push('/portal/teach/learn');
                            }}
                        /> */}
                    </OptionsRow>
                    <OptionsRow>
                        <StyledApplet
                            image={NewCreativeImg}
                            altText={'update-payment-method'}
                            btnText={'Update Payment Methods'}
                            onClick={() => {
                                history.push('/portal/advertiser/updatePaymentMethod');
                            }}
                        />
                        {/* <StyledApplet
                            image={ViewCampaignsImg}
                            altText={'update-strategy'}
                            btnText={'Update Strategy'}
                            onClick={() => {
                                history.push('/portal/teach/learn');
                            }}
                        />{' '} */}
                    </OptionsRow>
                </OptionsContainer>
            </SettingsContainer>
        </>
    );
};

export default Settings;
